import { observer } from 'mobx-react-lite';
import { Breadcrumbs, Typography, Link } from '@material-ui/core';
import React from 'react';
import { AdminPageLayout } from '../../components/uiComponents/UIComponents';
import { TermsOfServiceComponent } from '../../components/help/termsOfService';

export const TermsOfServicePage: React.FC = observer(() => {
    return (
        <AdminPageLayout
            header={
                <div>
                    <Breadcrumbs separator='›' aria-label='breadcrumb'>
                        <Link color='inherit' href='/'>
                            Home
                        </Link>
                        <Typography color='textPrimary'>Terms Of Service</Typography>
                    </Breadcrumbs>
                    <Typography variant='h4' gutterBottom>
                        Terms of Service
                    </Typography>
                </div>
            }
            content={<TermsOfServiceComponent />}
            maxWidth='md'
        />
    );
});
